module.exports = __webpack_public_path__ + "static/media/heart.d3284a8c.svg";